import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    scrollBarStyleOpened: {
        width: '300px !important'
    },
    scrollBarStyleClosed: {
        width: '0px !important'
    }
});
